import BaseLogger from './BaseLogger'
import LoggerType from './LoggerType'
import logos from './Logos'

export default {
  net(request, url, response) {
    BaseLogger.prettyLog(LoggerType.INFO, '请求地址', url)
    BaseLogger.json(LoggerType.INFO, '请求参数', request)
    BaseLogger.prettyLog(LoggerType.INFO, '返回结果', response)
  },
  json(tag, val) {
    BaseLogger.json(LoggerType.INFO, tag, val)
  },
  info(tag, val) {
    BaseLogger.prettyLog(LoggerType.INFO, tag, val)
  },
  warn(tag, val) {
    BaseLogger.prettyLog(LoggerType.WARN, tag, val)
  },
  assert(tag, val) {
    BaseLogger.prettyLog(LoggerType.ASSERT, tag, val)
  },
  error(tag, val) {
    BaseLogger.prettyLog(LoggerType.ERROR, tag, val)
  },
  log(tag, val) {
    BaseLogger.prettyLog(LoggerType.LOG, tag, val)
  },
  logo() {
    let index = Math.floor((Math.random() * logos.length))
    // BaseLogger.common(LoggerType.WARN, logos[index])
    // console.log('%c' + logos[index], 'color: #00C801;background: transparent;')
  },

}
